module.exports = __webpack_public_path__ + "media/images/mailers/header_banner-8dc4b25704873cca91b69f3428f768b2.png";